<template>
  <transition name="fade">
    <div
      v-if="isValidAttemptsRemainingNumber"
      class="attempt-warning"
      :class="[
        { 'attempt-warning__warning': isValidAttemptsRemainingNumber && hasAttemptsRemaining },
        { 'attempt-warning__error': isValidAttemptsRemainingNumber && !hasAttemptsRemaining },
      ]"
    >
      <v-icon class="attempt-warning__icon">warning</v-icon>
      <p
        v-if="isValidAttemptsRemainingNumber && hasAttemptsRemaining"
        class="attempt-warning__text"
      >
        <span v-if="['stepEmailCode', 'stepSmsCode', 'stepDidiCode'].includes(attemptsStep)" class="text--semibold">{{ $t(`${namespace}.incorrectVerify`) }}</span>
        <span v-else class="text--semibold">{{ $t(`${namespace}.incorrectPassword`) }}</span>
        {{ $t(`${namespace}.attemptsMessage`).replace('[ATTEMPTS]', attemptsRemaining) }}
      </p>

      <p
        v-if="isValidAttemptsRemainingNumber && !hasAttemptsRemaining"
        class="attempt-warning__text"
      >
        <span class="text--semibold">{{ $t(`${namespace}.exhaustedAttempts`) }}</span> {{ $t(`${namespace}.resetPasswordMessage`) }}
      </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoginAttemptsWarning',
  props: {
    attemptsRemaining: {
      type: [Number, String]
    },
    attemptsStep: {
      type: String
    }
  },
  computed: {
    isValidAttemptsRemainingNumber () {
      return typeof this.attemptsRemaining === 'number'
    },

    hasAttemptsRemaining () {
      return this.attemptsRemaining > 0
    }
  },
  data () {
    return {
      namespace: 'Components.LoginAttemptsWarning'
    }
  }
}
</script>

<style lang="scss" scoped>
.attempt-warning {
  align-items: center;
  background-color: #fffadd;
  border-bottom: 1px solid $gray-4;
  display: flex;
  justify-content: center;
  justify-items: center;
  left: 0;
  min-height: 60px;
  padding: 0 16px;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 1000;

  &.attempt-warning__warning {
    background-color: #fffadd;

    .attempt-warning__icon {
      color: $warning-2 !important;
    }
  }

  &.attempt-warning__error {
    background-color: $error2;

    .attempt-warning__icon {
      color: $error !important;
    }

    .attempt-warning__text {
      color: #a94442;

      span {
        color: $error;
      }
    }
  }
}

.attempt-warning__text {
  margin: 0;

  span {
    color: $gray-8;
    font-weight: 600;
  }
}

.attempt-warning__icon {
  margin-right: 8px;
}
</style>
